import {
  APIComponentAttributes,
  APIModelAttributes,
  APIWorkspaceAttributes,
  ArdoqId,
} from '@ardoq/api-types';
import { componentOperations, modelOperations } from '@ardoq/core';

export const isChildlessParent = (
  parentId: ArdoqId | null | undefined,
  componentsById: Record<ArdoqId, APIComponentAttributes>,
  workspacesById: Record<ArdoqId, APIWorkspaceAttributes>,
  modelsById: Record<ArdoqId, APIModelAttributes>
): boolean => {
  const parent = parentId ? componentsById[parentId] : undefined;
  if (!parent) return false;

  const workspace = workspacesById[parent.rootWorkspace];
  const model = workspace ? modelsById[workspace.componentModel] : undefined;
  if (!model) return true;

  const { componentTypesById } = modelOperations.getComponentTypes(model);
  return !componentOperations.canComponentHaveChildren(
    parent,
    componentTypesById,
    Boolean(model.flexible)
  );
};
